import PackageGroupCollectionGalleryItemEdit from './PackageGroupCollectionGalleryItemEdit'
import PackageGroupCollectionGalleryItemList from './PackageGroupCollectionGalleryItemList'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: PackageGroupCollectionGalleryItemList,
    edit: PackageGroupCollectionGalleryItemEdit
}
